import { render } from "./Checkbox.vue?vue&type=template&id=ad56d1d4"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"
script.render = render

export default script